export const AclLevel = {
  NONE: 'NONE',
  BROWSE: 'BROWSE',
  VIEW: 'VIEW',
  READ: 'READ',
  WRITE: 'WRITE',
  DELETE: 'DELETE'
}

export const FsiType = {
  FOLDER: 'FOLDER',
  DOCUMENT: 'DOCUMENT',
  REFERENCE: 'REFERENCE',
  PLACEHOLDER: 'PLACEHOLDER'
}

export const SystemFolderType = {
  WORKFLOWS: 'WORKFLOWS',
  REGULATED_CONTENT: 'REGULATED_CONTENT',
  TEMPLATES: 'TEMPLATES',
  FORMS: 'FORMS',
  CONTAMINATED: 'CONTAMINATED',
  UPLOAD: 'UPLOAD',
  REPORTS: 'REPORTS',
  SYSTEM_DOCUMENTS: 'SYSTEM_DOCUMENTS',
  EMAIL_UPLOADS: 'EMAIL_UPLOADS',
  INIT_ETMF_FILES: 'INIT_ETMF_FILES',
  DOCUMENT_MIGRATIONS_AND_EXPORTS: 'DOCUMENT_MIGRATIONS_AND_EXPORTS',
  SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS: 'SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS'
}

export const FsiLifecycleState = {
  APPROVED: 'APPROVED',
  DRAFT: 'DRAFT',
  EFFECTIVE: 'EFFECTIVE',
  HELPER_EXPIRING: 'HELPER_EXPIRING',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  OBSOLETE: 'OBSOLETE',
  REJECTED: 'REJECTED',
  RETIRED: 'RETIRED'
}

export const DocQualityIssuesList = [
  { value: 'BLANK', label: 'BLANK_PAGE_ISSUE' },
  { value: 'BLUR', label: 'ILLEGIBLE_PAGE_ISSUE' },
  { value: 'ORIENTATION', label: 'ORIENTATION_ISSUE' },
  { value: 'MISSING_PAGE', label: 'MISSING_PAGE_ISSUE' },
  { value: 'PAGINATION_MISSING', label: 'PAGINATION_MISSING_ISSUE' },
  { value: 'SIGNATURE_MISSING', label: 'SIGNATURE_MISSING_ISSUE' }
]
